module.exports = __webpack_public_path__ + "static/media/AngelsOfAether_PromoGuardian02.958862c2.jpg";